export default "__VITE_ASSET__fac8c10f__"